<template>
	<div class="device-wrap">
		<headerTitle title="实时监控" :sourceType="2">
			<template v-slot:left>
				<el-dropdown class="mydropdown" style="color: #fff; cursor: pointer" trigger="click"
					@command="handleDropmenu">
					<span class="el-dropdown-link"> {{ activeDevice.mountLocation }}<i
							class="el-icon-caret-bottom el-icon--right"></i> </span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(item, index) in deviceList" :command="item"
							:key="index">{{ item.mountLocation }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</template>

		</headerTitle>
		<div id="device" >
			<div id='video' ref="video" autoplay width="100%" muted>
			
			</div>
		</div>
	</div>
</template>

<script>
	import headerTitle from '@/views/bankScreen/components/headerTitle'
	import {deviceList,getPlayUrl,getPlayEzvizUrl} from "@/api/wms/index.js";
	export default {
		components: {
			headerTitle,

		},
		props: {
			businessType: {
				typeof: String,
				default: '',
			},
			businessId: {
				typeof: String,
				default: ''
			},
		},
		data() {
			return {
				deviceList: [],
				command: '20222',
				activeDevice:{mountLocation:'加载中--'},
				msgText:'视频加载中',
				flvPlayer:null
			}
		},
		watch: {
			businessId(newVal,oldVal){
				this.deviceList=[]
				if(this.flvPlayer){
					this.flvPlayer.destroy();
					this.flvPlayer = null;
				}
				if(newVal){
					this.getDeviceList()
				}else{
					this.activeDevice = {mountLocation:'暂无视频'}
				}
			}
		},
		created() {
			//this.getDeviceList()
		},
		methods: {
			getDeviceList(){
				deviceList({"businessType": this.businessType,"businessIdList": [this.businessId]}).then(res=>{
					console.log(res)
					if(res.status==200&&res.data.code==200&&res.data.result&&res.data.result.length>0){
						this.deviceList=res.data.result
						this.activeDevice=this.deviceList[0]
						this.playVideo(this.activeDevice)
					}else{
						this.activeDevice = {mountLocation:'暂无视频'}
					}
				})
			},
			handleDropmenu(command) {
				console.log(command)
				this.activeDevice = command
				if(this.flvPlayer){
					this.flvPlayer.destroy();
					this.flvPlayer = null;
				}
				
				// this.player&&this.player.stop()

				this.playVideo(this.activeDevice)
				

			},
			playVideo(deviceInfo){
				
				
				if (deviceInfo.deviceType == 3) {
					getPlayEzvizUrl({
						deviceCode: deviceInfo.deviceCode,
						channelCode: deviceInfo.channelCode,
						ezvizId: deviceInfo.ezvizId
				
					}).then(res => {
						console.log(res)
						if(res.status!=200){
							
							return
						}
						if (res.data.code == 200) {
							this.$nextTick(function () {
								let w = document.getElementById('video').offsetWidth
								let h = document.getElementById('video').clientHeight
								if(!this.player){
									this.player = new EZUIKit.EZUIKitPlayer({
										id: 'video',
										url: res.data.result.url,
										accessToken: res.data.result.accessToken,
										template: "pcLive",
										width: w,
										height: h,
										showPTZControl: 'none'
									})
								}else{
									this.player.stop()
									.then(()=>{
										this.player.play({url:res.data.result.url,accessToken:res.data.result.accessToken});
									});
								}
								
								console.log(this.player)
				
							});
				
				
				
						}
						console.log(res)
					})
				} else {
					
					getPlayUrl({
						deviceCode: deviceInfo.deviceCode,
						channelCode: deviceInfo.channelCode,
					}).then(res => {
						console.log(res)
						if(res.status!=200){
							
							return
						}
						
						if (res.data.code == 200) {
							
							this.$nextTick(function () {
								if (this.flvPlayer) {
									
									this.flvPlayer.destroy();
								
									this.flvPlayer = null;
								
								}
								
								var videoElement = document.getElementById("video");
								console.log(res.data.result.flv)
								this.flvPlayer = new Jessibuca({
									container: videoElement,
									videoBuffer: 0.2, // 缓存时长
									isResize: false,
									text: "",
									loadingText: "加载中",
									debug: false,
									showBandwidth: false, // 显示网速
									decoder:'/decoder.js',
									operateBtns: {
										fullscreen: false,
										screenshot: false,
										play: false,
										audio: false,
										record:false
									},
									forceNoOffscreen: false,
									isNotMute: false,
								})
								this.flvPlayer.on("load",  ()=> {
									this.msgText=''
								});
								this.flvPlayer.on("pause",  ()=> {
									console.log("on pause");
								});
								this.flvPlayer.on("play",  ()=> {
									this.msgText = ''
								});
								this.flvPlayer.on("error",  ()=> {
									this.msgText = '摄像头加载失败'
								});
								this.flvPlayer.play(res.data.result.wssFlv);
								return
								this.flvPlayer = flvjs.createPlayer({
									type: 'mp4',
									url: res.data.result.httpsFmp4, //你的url地址
									isLive: true,
									hasAudio: false,
									hasVideo: true,
									withCredentials: false,
									autoplay: true,
									cors: true,
								});
								this.flvPlayer.attachMediaElement(videoElement);
								this.flvPlayer.load();
								this.flvPlayer.play();
								this.msgText = ''
				
							})
						}
						console.log(res)
					}).catch(res => {
						this.msgText = '摄像头加载失败'
						console.log(res)
					})
				}
			}
			
		},
	}
</script>

<style scoped lang="scss">
	.device-wrap {
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: space-between;
	}

	#device {
		
		background-color: #ff0;
		width: 5.38rem;
		height: 3rem;
		margin-left: 0.29rem;
	}
	#video {
		width: 100%;
		height: 100%;
		background: url(~@/assets/back/video.png)no-repeat center center;
		text-align: center;
		background-size: 100%;
		span {
	
			color: #000;
			line-height: 4rem;
		}
	}
</style>